import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import DeleteAccount from "@/pages/DeleteAccount";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/lib/lang";
import { StoreLinksProvider } from "@/lib/storeLinks";
import { SmoothScroll } from "@/components/SmoothScroll";
import { WaitlistToast } from "@/components/WaitlistToast";
import { Intro } from "@/components/Intro";
import { Cursor } from "@/components/Cursor";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import AppDetail from "@/pages/AppDetail";
import Privacy from "@/pages/Privacy";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <LangProvider>
      <StoreLinksProvider>
      <BrowserRouter>
        <SmoothScroll />
        <WaitlistToast />
        <Intro />
        <Cursor />
        <Nav />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/apps/:slug" element={<AppDetail />} />
            <Route path="/apps/:slug/privacy" element={<Privacy />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/delete-account" element={<DeleteAccount />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <Toaster theme="dark" position="bottom-right" />
      </BrowserRouter>
      </StoreLinksProvider>
    </LangProvider>
  );
}

export default App;
